var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilePurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1C1.5 0.447716 1.94771 0 2.5 0H7.5L7.5 4C7.5 4.55228 7.94772 5 8.5 5L12.5 5L12.5 13C12.5 13.5523 12.0523 14 11.5 14L2.5 14C1.94772 14 1.5 13.5523 1.5 13V1ZM4.7 7H3.5V8H4.7V7ZM10.5 7H5.9V8H10.5V7ZM4.7 9H3.5V10H4.7V9ZM10.5 9H5.9V10H10.5V9ZM3.5 11H4.7V12H3.5V11ZM5.9 11H10.5V12H5.9V11Z",
    fill: "#7936D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0172 4L8.5 4V0.482842C8.5 0.304661 8.71543 0.215428 8.84142 0.34142L12.1586 3.65858C12.2846 3.78457 12.1953 4 12.0172 4Z",
    fill: "#7936D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePurple);
export default __webpack_public_path__ + "static/media/file_purple.9becb93b.svg";
export { ForwardRef as ReactComponent };